import BookIcon from '../../../images/BookIcon.svg'
import background2 from '../../../images/background1.png'
import background3 from '../../../images/background2.png'
import background1 from '../../../images/background3.png'
import BarChartIcon from '../../../images/barChartIcon.svg'
import BellIcon from '../../../images/bellIcon.svg'
import BoxesIcon from '../../../images/boxesIcon.svg'
import bulkSettingsIcon from '../../../images/bulkSettingsIcon.svg'
import businessRoleIcon from '../../../images/businessRoleIcon.svg'
import businessUsersIcon from '../../../images/businessUsersIcon.svg'
import CalenderIcon from '../../../images/calenderIcon.svg'
import CheckListIcon from '../../../images/checkListIcon.svg'
import clockIcon from '../../../images/clockIcon.svg'
import ComputerIcon from '../../../images/computerIcon.svg'
import homeWifiIcon from '../../../images/homeWifiIcon.svg'
import NotificationIcon from '../../../images/notificationIcon.svg'
import PenIcon from '../../../images/penIcon.svg'
import PenIcon2 from '../../../images/penIcon2.svg'
import refreshLineIcon from '../../../images/refreshLineIcon.svg'
import SettingsIcon from '../../../images/settingsIcon.svg'
import shieldCross from '../../../images/shieldCross.svg'
import timerIcon from '../../../images/timerIcon.svg'

export const createBookingsItem = () => [
  {
    id: 'box1',
    title: 'createBookingTitle1',
    description: 'createBookingContent1',
    icon: CheckListIcon,
  },

  {
    id: 'box2',
    title: 'createBookingTitle2',
    description: 'createBookingContent2',
    icon: CalenderIcon,
  },
  {
    id: 'box3',
    title: 'createBookingTitle3',
    description: 'createBookingContent3',
    icon: BellIcon,
  },
  {
    id: 'box4',
    title: 'createBookingTitle4',
    description: 'createBookingContent4',
    icon: NotificationIcon,
  },
]

export const overviewItem = () => [
  {
    id: 'box1',
    title: 'overviewTitle1',
    description: 'overviewContent1',
    icon: BookIcon,
  },
  {
    id: 'box2',
    title: 'overviewTitle2',
    description: 'overviewContent2',
    icon: BarChartIcon,
  },
  {
    id: 'box3',
    title: 'overviewTitle3',
    description: 'overviewContent3',
    icon: BoxesIcon,
  },
  {
    id: 'box4',
    title: 'overviewTitle4',
    description: 'overviewContent4',
    icon: PenIcon,
  },
]

export const facilityManagementItem = () => [
  {
    id: 'box1',
    icon: SettingsIcon,
    title: 'FacilityManagementTitle1',
    description: 'FacilityManagementContent1',
    backgroundImage: background1,
  },
  {
    id: 'box2',
    icon: ComputerIcon,
    title: 'FacilityManagementTitle2',
    description: 'FacilityManagementContent2',
    backgroundImage: background2,
  },
  {
    id: 'box3',
    icon: PenIcon2,
    title: 'FacilityManagementTitle3',
    description: 'FacilityManagementContent3',
    backgroundImage: background3,
  },
]

export const bookingManagementItem = () => [
  {
    title: 'bookingManagementTitle1',
    icon: bulkSettingsIcon,
    description: 'bookingManagementDesc1',
  },
  {
    title: 'bookingManagementTitle2',
    icon: timerIcon,
    description: 'bookingManagementDesc2',
  },
  {
    title: 'bookingManagementTitle3',
    icon: clockIcon,
    description: 'bookingManagementDesc3',
  },
  {
    title: 'bookingManagementTitle4',
    icon: homeWifiIcon,
    description: 'bookingManagementDesc4',
  },
  {
    title: 'bookingManagementTitle5',
    icon: refreshLineIcon,
    description: 'bookingManagementDesc5',
  },
  {
    title: 'bookingManagementTitle6',
    icon: shieldCross,
    description: 'bookingManagementDesc6',
  },
]

export const accessManagementItem = () => [
  {
    title: 'businessRolesTabName',
    icon: businessRoleIcon,
    description: 'accessManagementDesc1',
  },
  {
    title: 'businessUserTabName',
    icon: businessUsersIcon,
    description: 'accessManagementDesc2',
  },
]
